<script>
export default {
  name: "FraudPreventionView"
}
</script>

<template>
  <router-view></router-view>
</template>
